import React, { useEffect, useState } from "react";
import SavedCards from "./SavedCards";
import { BillingAddress } from "./BillingAddress";
import { useDispatch, useSelector } from "react-redux";
import { addBillAdd, editBillAdd, setPayementInformation } from "../../../../store/actions";
import CustomLoader from "../../../Common/CustomLoader";
import { getPlanSpecificationDetails } from "../../../../store/menu/home/actions";
import * as Yup from "yup"
import { useFormik } from "formik"
import form_input_patterns from "../../../../constants/form_input_patterns";
import form_messages from "../../../../constants/form_messages";

const PaymentInformation = () => {

    const dispatch = useDispatch();
    const BillSetState = useSelector(state => state.BillSet)
    const { cardList,
        cardListLoading,
        cardAddLoading,
        cardAdded,
        addCardErr,
        defCardErr,
        remCardErr,
        defaultCardLoading,
        cardRemoveLoading,
        billAddress,
        getBillAddressLoading,
        billAddressLoading,
        editBillAddressLoading,
        repMessage,
        editBillAddErr,
        addBillAddErr,
        setPayementInfo,
        cardAddLoadingForPaymentInfo,
        billAdressFetched
    } = BillSetState

    const PlanUserState = useSelector(state => state.Plan)
    const { planAddLoading, planAdded } = PlanUserState
    const planSpecificaionState = useSelector(state => state.Home?.planSpecificationDetails?.plan)
    const { trial_act } = planSpecificaionState
    const [billfetched, setBillFetched] = useState(false);


    const initialValuesForForm = {
        bill_name: billAddress?.bill_name ? billAddress.bill_name : "",
        bill_email: billAddress?.bill_email ? billAddress.bill_email : "",
        add_l1: billAddress?.add_l1 ? billAddress.add_l1 : "",
        add_l2: billAddress?.add_l2 ? billAddress.add_l2 : "",
        city: billAddress?.city ? billAddress.city : "",
        state: billAddress?.state ? billAddress.state : "",
        zip_code: billAddress?.zip_code ? billAddress.zip_code : "",
        country_name: billAddress?.country_name ? billAddress.country_name : "",
        // gstin_no: billAddress?.gstin_no ? billAddress.gstin_no : ""
    }

    let initialValidationShape =
        Yup.object().shape({
            bill_name: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Billing name")
                )
                .min(1, form_messages.Billing_Address.bill_name.MIN1MAX50).max(50, form_messages.Billing_Address.bill_name.MIN1MAX50).required(form_messages.Billing_Address.bill_name.REQUIRED).trim()
            ,
            bill_email: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Billing email")
                )
                .email(form_messages.Billing_Address.bill_email.INVALID).required(form_messages.Billing_Address.bill_email.REQUIRED).trim()
                .test("bill_email", form_messages.Signup.email.Invalid, function (value) {
                    const emailRegex = form_input_patterns.EMAIL
                    return emailRegex.test(value)
                })
            ,
            add_l1: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Address line 1")
                )
                .min(1, form_messages.Billing_Address.address_line.ADD_L1.MIN1MAX100).max(100, form_messages.Billing_Address.address_line.ADD_L1.MIN1MAX100).required(form_messages.Billing_Address.address_line.ADD_L1.REQUIRED).trim(),
            add_l2: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Address line 2")
                )
                .min(1, form_messages.Billing_Address.address_line.ADD_L2.MIN1MAX100).max(100, form_messages.Billing_Address.address_line.ADD_L2.MIN1MAX100).trim(),
            city: Yup.string().trim()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("City")
                )
            ,
            state: Yup.string()
                // .matches(
                //   form_input_patterns.ONLYENGLISHTEXT,
                //   form_messages.Common.INVALID("State")
                // )
                .min(2, form_messages.Billing_Address.State.MIN2MAX100)
                .max(100, form_messages.Billing_Address.State.MIN2MAX100)
                .required(form_messages.Billing_Address.State.REQUIRED)
                .trim(),
            country_name: Yup.string().required(form_messages.Billing_Address.Country_name.REQUIRED).trim(),
            zip_code: Yup.string()
                .required(form_messages.Billing_Address.Zip_code.REQUIRED)
                .matches(form_input_patterns.VALIDZIPCODE, form_messages.Billing_Address.Zip_code.INVALID)

        })

    const [validationShape, setValidationShape] = useState(initialValidationShape);



    const validationType = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: initialValuesForForm,
        validationSchema: validationShape,
        onSubmit: values => {
            if (!billAddress && cardList.count > 0) {
                dispatch(addBillAdd(values))
            }
            else if (billAddress) {
                dispatch(editBillAdd(values))
            }
        },
    })

    //effects
    useEffect(() => {
        if (setPayementInfo?.submitCardDetails && !billAddress && (cardList?.count === 1)) {
            validationType.handleSubmit()
        }
    }, [setPayementInfo?.submitCardDetails, billAddress, cardList?.count])


    useEffect(() => {
        if (validationType.errors && Object.keys(validationType.errors).length > 0 && setPayementInfo.cardDetailsFilled) {
            dispatch(setPayementInformation({ submitCardDetails: false, submitted: false }))

        }
    }, [validationType.errors, setPayementInfo?.submitted])

    useEffect(() => {
        let billErrors;
        if (validationType.errors && Object.keys(validationType.errors).length > 0) {
            billErrors = true

        }
        else {
            billErrors = false

        }
        dispatch(setPayementInformation({ billingErrors: billErrors, submitCardDetails: (setPayementInfo?.submitted && (setPayementInfo.cardDetailsFilled ? !billErrors : true)) ? true : false }))

    }, [validationType.errors, setPayementInfo?.cardDetailsFilled, setPayementInfo?.submitted])

    useEffect(() => {
        if (validationType.values && Object.values(validationType.values)?.some(ele => ele?.length > 0)) {
            dispatch(setPayementInformation({ billingAdressFilled: true }))
        }
    }, [validationType.values])

    useEffect(() => {
        if ((setPayementInfo?.billingAdressFilled || setPayementInfo?.from === "card") && !billAddress && !cardList) {

            const handleBeforeUnload = (e) => {
                const confirmationMessage = 'Are you sure you want to leave?';
                e.returnValue = confirmationMessage;
                return confirmationMessage;


            };
            window.addEventListener('beforeunload', handleBeforeUnload);


            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);

            };
        }
    }, [setPayementInfo?.billingAdressFilled, setPayementInfo?.from]);




    useEffect(() => {
        if ((cardList?.count > 0 && billAddress) && !planAddLoading && planAdded && !trial_act) {
            dispatch(getPlanSpecificationDetails({}))

        }

    }, [billAddress, cardList?.count, planAddLoading, planAdded, trial_act])

    useEffect(() => {
        dispatch(setPayementInformation({ submitCardDetails: false, submitted: false, cardDetailsFilled: false, submitBillingAdress: false, cardAddLoadingForPaymentInfo: false, billAddressLoading: false, cardAddLoading: false }))
        return () => {
            dispatch(setPayementInformation({ submitCardDetails: false, submitted: false, cardDetailsFilled: false, submitBillingAdress: false, cardAddLoadingForPaymentInfo: false, billingAdressFilled: false }))

        }
    }, [])

    //functions
    const handleClickSaveAndPay = () => {
        if (!billAddress) {
            validationType.handleSubmit()
        }
        dispatch(setPayementInformation({ submitted: true }))

    }

    const onClickCancel = () => {
        dispatch(setPayementInformation({ cancelCardDetails: true }))

    }

    return (
        <>
            <div className={`payment-information ${((!billAddress || cardList?.count === 0) && (!getBillAddressLoading && !cardListLoading)) ? "withfooter" : ""} ${(cardList?.count > 0 && (!getBillAddressLoading && !cardListLoading)) ? "edit-view" : ""} ${getBillAddressLoading || cardListLoading ? "loading" : ""}`}>
                {
                    getBillAddressLoading || cardListLoading ?
                        <CustomLoader text={"Fetching payment information"} />
                        :
                        <>
                            <SavedCards
                                cardList={cardList}
                                cardListLoading={cardListLoading}
                                cardAddLoading={cardAddLoading}
                                cardAdded={cardAdded}
                                repMessage={repMessage}
                                addCardErr={addCardErr}
                                defCardErr={defCardErr}
                                remCardErr={remCardErr}
                                defaultCardLoading={defaultCardLoading}
                                cardRemoveLoading={cardRemoveLoading}
                                billfetched={billfetched}
                            />

                            <div className="billing-details-menu-border payment-information" />
                            <BillingAddress cardList={cardList} billAddress={billAddress} getBillAddressLoading={getBillAddressLoading} billAddressLoading={billAddressLoading} editBillAddressLoading={editBillAddressLoading} editBillAddErr={editBillAddErr} repMessage={repMessage} addBillAddErr={addBillAddErr} setBillFetched={setBillFetched} validationType={validationType} validationShape={validationShape} initialValuesForForm={initialValuesForForm} initialValidationShape={initialValidationShape} setValidationShape={setValidationShape} />

                        </>
                }

            </div>
            {
                ((!billAddress || cardList?.count === 0) && (!getBillAddressLoading && !cardListLoading)) &&
                <div className='save-card-btn payment-information'>
                    <button disabled={billAddressLoading || setPayementInfo?.cardAddLoading} className={`${billAddressLoading || setPayementInfo?.cardAddLoading ? "btn-cancel  button-disabled" : "btn-cancel "}`} type='button' onClick={() => {
                        onClickCancel();
                    }}>Cancel</button>
                    <button disabled={billAddressLoading || setPayementInfo?.cardAddLoading} className={`${billAddressLoading || setPayementInfo?.cardAddLoading ? "btn-save me-0 button-disabled" : "btn-save me-0"}`} type='submit' onClick={handleClickSaveAndPay}>
                        {cardList?.count === 0 || cardAddLoadingForPaymentInfo ? "Save & Pay" : "Save"}
                        {(billAddressLoading || setPayementInfo?.cardAddLoading) &&
                            <div className="spinner-container spinner-border">
                            </div>}
                    </button>
                </div>
            }
        </>

    )
}
export default PaymentInformation